import { SIGNUP } from "./login";

// Route search params
export const AS_CHILD_SEARCH_PARAM = "asChild";

export const FROM_PAGE_SEARCH_PARAM = "fromPage";

export const POST_LOGIN_URL_SEARCH_PARAM = "postLoginUrl";

export const POST_VERIFY_EMAIL_URL_SEARCH_PARAM = "postVerifyEmailUrl";

export const ERROR_TEXT_SEARCH_PARAM = "errorText";

export const LOGIN_MODE_PARAM = "mode";

export const LOGIN_EMAIL_PARAM = "email";

export const DRAFT_TASK_ID_PARAM = "draftTaskId";

// Route Urls
export const HOME_PAGE_URL = "/";

export const CLIENT_ROUTE_PREFIX = "/app";

export const DASHBOARD_URL = `${CLIENT_ROUTE_PREFIX}/dashboard`;

export const LOGIN_URL = "/login";

export const SIGN_UP_URL = `/login?${LOGIN_MODE_PARAM}=${SIGNUP}`;

export const COMMUNITY_URL = "/community";

export const MY_TASKS_URL = `${CLIENT_ROUTE_PREFIX}/my-tasks`;

export const USER_TASK_DETAILS_URL = `${CLIENT_ROUTE_PREFIX}/user-task/details`;

export const USER_TASK_UPDATE_TRACK_URL = `${CLIENT_ROUTE_PREFIX}/user-task/update-track`;

export const COMMUNITY_TASK_DETAILS_URL = "/community-task/details";

export const COMMUNITY_TASK_UPDATE_PICK_URL = `/community-task/update-pick`;

export const ADD_USER_TASK_URL = `/user-task/add-task`;

export const INFER_TASKS_URL = `${CLIENT_ROUTE_PREFIX}/infer-tasks`;

export const ABOUT_US_URL = "/about-us";

export const PRIVACY_POLICY_URL = "/privacy-policy";

export const FEEDBACK_URL = `${CLIENT_ROUTE_PREFIX}/feedback`;

export const CAREERS_URL = "/careers";

export const ERROR_URL = `/error`;

export const VERIFY_EMAIL_URL = `${CLIENT_ROUTE_PREFIX}/verify-email`;

export const NOT_FOUND_URL = `/404`;

// Route hash params
export const AI_USAGE_HASH_PARAM = "ai-usage";

// Page names for internal use
export const HOME_PAGE = "HOME";

export const DASHBOARD_PAGE = "DASHBOARD";

export const LOGIN_PAGE = "LOGIN";

export const ALL_TASKS_PAGE = "ALL_TASKS";

export const MY_TASKS_PAGE = "MY_TASKS";

export const ADD_TASK_PAGE = "ADD_TASK";

export const INFER_TASKS_PAGE = "INFER_TASKS";

export const USER_TASK_DETAILS_PAGE = "USER_TASK_DETAILS";

export const USER_TASK_UPDATE_TRACK_PAGE = "USER_TASK_UPDATE_TRACK";

export const COMMUNITY_PAGE = "COMMUNITY";

export const COMMUNITY_TASK_DETAILS_PAGE = "COMMUNITY_TASK_DETAILS";

export const COMMUNITY_TASK_UPDATE_PICK_PAGE = "COMMUNITY_TASK_UPDATE_PICK";

export const ABOUT_US_PAGE = "ABOUT_US";

export const PRIVACY_POLICY_PAGE = "PRIVACY_POLICY";

export const FEEDBACK_PAGE = "FEEDBACK";

export const CAREERS_PAGE = "CAREERS";

export const EMAIL_VERIFY_PAGE = "EMAIL_VERIFY_PAGE";

export const GENERIC_BLOG_TASK_PAGE = "GENERIC_BLOG_TASK_PAGE";

export const BLOG_LANDING_PAGE = "BLOG_LANDING_PAGE";

// Filter route search params
export const DAY_SEARCH_PARAM = "day";

export const IMPACT_CATEGORY_SEARCH_PARAM = "impactCategory";

export const FETCH_MY_TASKS_SEARCH_PARAM = "fetchMyTasks";

export const USAGE_PERIOD_SEARCH_PARAM = "usagePeriod";
